import { BASE_URL } from '@/config'

// Criar um novo funcionario
export async function createEmployee(employeeData) {
  try {
    const response = await fetch(`${BASE_URL}/employees`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(employeeData),
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao criar funcionário')
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao criar funcionário:', error)
    throw error
  }
}

// Obter todos os funcionarios
export async function getEmployees() {
  try {
    const response = await fetch(`${BASE_URL}/employees`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao buscar funcionários')
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao buscar funcionários:', error)
    throw error
  }
}

// Atualizar um funcionario pelo ID
export async function updateEmployee(id, employeeData) {
  if (!id) {
    throw new Error('O ID do funcionário é obrigatório para atualização.')
  }

  try {
    const response = await fetch(`${BASE_URL}/employees/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(employeeData),
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao atualizar funcionário')
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao atualizar funcionário:', error)
    throw error
  }
}

// Excluir um funcionario pelo ID
export async function deleteEmployee(id) {
  if (!id) {
    throw new Error('O ID do funcionário é obrigatório para exclusão.')
  }

  try {
    const response = await fetch(`${BASE_URL}/employees/${id}`, {
      method: 'DELETE',
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao excluir funcionário')
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao excluir funcionário:', error)
    throw error
  }
}

// Buscar um funcionario pelo ID
export async function getEmployeeById(id) {
  if (!id) {
    throw new Error('O ID do funcionário é obrigatório para busca.')
  }

  try {
    const response = await fetch(`${BASE_URL}/employees/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao buscar funcionário')
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao buscar funcionário:', error)
    throw error
  }
}

// Obter todos os funcionarios de uma empresa
export async function getEmployeesByEnterpriseId(enterpriseId) {
  try {
    const response = await fetch(
      `${BASE_URL}/employees/enterprise/${enterpriseId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(
        errorData.message || 'Erro ao buscar funcionários da empresa'
      )
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao buscar funcionários da empresa:', error)
    throw error
  }
}
